import Icon from 'components/base/Icon';
import { LBTabs, LBTabsList, LBTabsTrigger } from '@linearb/buzz';

export const FORECAST_VIEW_TYPES = {
  COLUMN_CHART: 'COLUMN_CHART',
  CALENDAR: 'CALENDAR'
};

const ViewTypeSelector = ({ value, onChange }) => {
  const viewTypes = [
    { value: FORECAST_VIEW_TYPES.CALENDAR, icon: 'CalendarIcon' },
    { value: FORECAST_VIEW_TYPES.COLUMN_CHART, icon: 'ChartSideBySide' }
  ];

  return (
    <div className='inline-flex justify-end'>
      <LBTabs value={value} onValueChange={viewType => onChange(viewType)}>
        <LBTabsList>
          {viewTypes.map(currViewType => {
            const isSelected = currViewType.value === value;
            const iconColor = isSelected ? 'white' : 'shuttleGray';

            return (
              <LBTabsTrigger
                key={currViewType.value}
                value={currViewType.value}
              >
                <Icon name={currViewType.icon} color={iconColor} />
              </LBTabsTrigger>
            );
          })}
        </LBTabsList>
      </LBTabs>
    </div>
  );
};

export default ViewTypeSelector;
